import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import * as BaseComp from 'components/bolt/footer/footer.js';
import s from 'components/bolt/footer/footer.sss';
import { getGeoFromIPAsync, isUserInEU } from 'utils/clientUtils';
import parseQueryString from 'utils/parseQueryString';

class StaticButton extends Component {
	shouldComponentUpdate() {
		return false;
	}
	render(props) {
		return <button type="button" {...props} />;
	}
}

export default class Footer extends BaseComp.default {

	componentDidMount() {
		super.componentDidMount();
		getGeoFromIPAsync().then((geo) => {
			this.setState({ geoFromIP: geo });
		});
		isUserInEU().then(userInEU => this.setState({ userInEU }));
	}

	shouldRemoveCookiePolicy() {
		// should remove on 1 Jan 2023, 6:00 PT
		// which is 1 Jan 2012, 14:00 UTC
		const datePassed = Date.now() > Date.UTC(2023, 0, 1, 14);
		const query = parseQueryString();
		return datePassed || (__IS_LOCAL__ || __IS_DEMO__ && query.hideCookiePolicy);
	}

	renderLinks(items, type) {
		let itemsCopy = {};

		if (this.shouldRemoveCookiePolicy() && items.cookies) {
			Object.keys(items).forEach((key) => {
				if (key === 'cookies') return;
				itemsCopy[key] = items[key];
			});
		} else {
			itemsCopy = items;
		}

		const base = super.renderLinks(itemsCopy, type);
		const usingOneTrust = accessNested(this.props, 'store.appData.options.oneTrustCookieConsent.scripts');

		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		const underAge = ageGateEnabled && !isOfAge;

		if (type !== 'link' || !usingOneTrust || underAge) {
			return base;
		}

		let cookieLinkText = '';

		if (typeof window !== 'undefined') {
			cookieLinkText = window.OneTrust?.GetDomainData()?.AlertMoreInfoText;
		}
		
		if (Store.get().appData.footer.defaultFooter.noParamountExtraLink) {
			return base;
		}

		return [].concat(base, (
			<li class={s.linkWrapper} key="onetrust-manage-cookies">
				<StaticButton
					class={joinClasses(s.linkLink, 'ot-sdk-show-settings')}
					role="button"
				>
					{cookieLinkText}
				</StaticButton>
			</li>
		));
	}
}
